import React, { useEffect } from 'react';
import AppRouter from './components/AppRouter';
import Header from './components/Header';
import { PublicRoutesEnum } from './utils/router';
import { storageToken } from './utils/storage';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { State } from './redux/reducer';
import { shouldLoadUsersSelector } from './redux/features/auth/selectors';
import { loadUserInit } from './redux/features/userInit/actions';

const App = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  const shouldUserInit = useSelector((state: State) =>
    shouldLoadUsersSelector(state),
  );

  useEffect(() => {
    shouldUserInit && storageToken() && dispatch(loadUserInit());
  }, [dispatch, shouldUserInit]);
  return (
    <>
      {location.pathname !== PublicRoutesEnum.AUTH && storageToken() && (
        <Header />
      )}
      <AppRouter />
    </>
  );
};

export default App;
